export default __webpack_public_path__ + "static/media/aocaboteatro1.fccc4af6.png";